import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { hasSeatShortage } from "@components/table/members/bulk-actions/bulk-seats-helper";
import { Alert } from "@flat-ui";
import { nounPluralize } from "@utils/data-display";

/**
 * Tells the user that the selection needs more seats than the workspace has left, and to reduce it,
 * or nothing when the seats are enough, see hasSeatShortage. The counts are kept from translation,
 * so that the sentence is translated once rather than for every count.
 */
export function SeatShortageAlert(props) {
  const $ = _c(16);
  const {
    numberOfChangingMembers,
    seatsAvailable
  } = props;
  if (!hasSeatShortage(props)) {
    return null;
  }
  let t0;
  if ($[0] !== seatsAvailable) {
    t0 = nounPluralize({
      counter: seatsAvailable,
      word: "seat",
      shouldShowCounter: false
    });
    $[0] = seatsAvailable;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const seats = t0;
  let t1;
  if ($[2] !== numberOfChangingMembers) {
    t1 = nounPluralize({
      counter: numberOfChangingMembers,
      word: "member",
      shouldShowCounter: false
    });
    $[2] = numberOfChangingMembers;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const members = t1;
  let t2;
  if ($[4] !== seatsAvailable) {
    t2 = <var>{seatsAvailable}</var>;
    $[4] = seatsAvailable;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== numberOfChangingMembers) {
    t3 = <var>{numberOfChangingMembers}</var>;
    $[6] = numberOfChangingMembers;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== members || $[9] !== seats || $[10] !== t2 || $[11] !== t3) {
    t4 = <span>Only {t2} {seats} left for{" "}{t3} {members}. Please reduce your selection.</span>;
    $[8] = members;
    $[9] = seats;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      mb: SPACE_ELEMENTS_OF_MODAL
    };
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4) {
    t6 = <Alert title={t4} variant="error" sx={t5} />;
    $[14] = t4;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}